import { pageSizeEnum } from '@/constants/pageSizeOptionList';
const state = {
    /** 이력 다이얼로그 오픈 */
    isDialogOpen: false,
    filterOption: {
        /** 한 페이지당 보여질 항목 개수 */
        pageSize: Number(pageSizeEnum['20']),
        /** 현재 페이지 */
        pageNumber: 1,
        /** 설정 유형 */
        selectedType: '',
        /** 조회기간 */
        betweenDate: [],
    },
    /** 조회 허브 */
    selectedHub: '',
    /** 조회 상점 */
    selectedStore: '',
    /** 이력 list */
    list: [],
    paginationData: {},
    /** 조회 허브 list */
    hubList: [],
    /** 조회 상점 list */
    storeList: [],
    /** 이력 조회 중 */
    isFetching: true,
    /** 이력 조회 실패 */
    isError: false,
};
export default state;
